import { FunnelStatus } from './types'

export const getFunnelCheckStatus = (status: FunnelStatus) => {
  switch (status) {
    case FunnelStatus.Successful:
      return 'success'
    case FunnelStatus.Failed:
      return 'danger'
    default:
      return 'warning'
  }
}
